<template>
  <div class="content_boxs_l">
    <div class="content_box">
      <div class="line"></div>
      <div class="title_text">预约上门</div>
    </div>
    <div class="content_boxs">
      <div class="content_box_title" style="margin-bottom: 30px">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">填写预约上门信息</div>
      </div>
      <div class="box_op">
        <div style="width: 489px; margin-right: 70px">
          <div class="fill_in_list">
            <div class="fill_in_list_l">
              <div class="fill_in_title">姓名</div>
              <div class="fill_in_title_l">*</div>
            </div>
            <input
              type="text"
              v-model="form.name"
              placeholder="请输入联系人姓名"
              class="input_box"
            />
          </div>
          <div class="fill_in_list">
            <div class="fill_in_list_l">
              <div class="fill_in_title">电话</div>
              <div class="fill_in_title_l">*</div>
            </div>
            <input
              type="text"
              v-model="form.phone"
              placeholder="请输入联系人电话"
              class="input_box"
            />
          </div>
          <div class="fill_in_list">
            <div class="fill_in_list_l">
              <div class="fill_in_title">取件地址</div>
              <div class="fill_in_title_l">*</div>
            </div>
            <input
              type="text"
              v-model="form.address"
              placeholder="请输入取件地址"
              class="input_box"
            />
          </div>
          <el-button
            class="last_step_l"
            :loading="loading"
            type="primary"
            @click="subscribeHistory"
            round
            >提交寄件</el-button
          >
        </div>
        <div class="explain_box">
          <div class="explain_box_title">
            <img class="icon_img" src="@/assets/img/wenhao.png" alt="" />
            <div>预约上门说明</div>
          </div>
          <div class="explain_box_text">
            {{ explain }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
export default {
  data() {
    return {
      loading: false,
      form: {
        address: "",
        phone: "",
        name: "",
      },
      explain: "",
    };
  },
  created() {
    this.systemSettings();
  },
  methods: {
    systemSettings() {
      var data = {
        enableprofileupdate: 0,
      };
      crudDept.systemSettings(data).then((res) => {
        this.explain = res.content[0].schedulepickuptext;
      });
    },
    subscribeHistory() {
      if (
        this.form.address == "" ||
        this.form.phone == "" ||
        this.form.name == ""
      ) {
        this.$message.error("请完善预约信息");
        return false;
      }
      this.loading = true;
      crudDept
        .subscribeHistory(this.form)
        .then((res) => {
          this.$message({
            message: "预约成功，请等待工作人员联系您！",
            type: "success",
          });
          (this.form = {
            address: "",
            phone: "",
            name: "",
          }),
            (this.loading = false);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.icon_img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
.box_op {
  display: flex;
  align-items: flex-start;
}
.explain_box {
  width: 489px;
  min-height: 180px;
  background: #ffffff;
  border: 1px solid #d4d4d4;
  opacity: 1;
  padding: 30px 24px;
  box-sizing: border-box;
  /* flex: 1; */
}
.explain_box_title {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}
.explain_box_text {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #999999;
  margin-top: 20px;
}
.last_step_l {
  width: 120px !important;
  height: 44px !important;
  background: #5178ff !important;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  line-height: 44px !important;
  border-radius: 22px;
  margin-top: 53px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
  text-align: center;
  padding: 0;
}
.content_boxs_l {
  background-color: #fff;
  width: 100%;
  height: 100%;
  background: #ffffff;
}
.content_box {
  width: 100%;
  height: 93px;
  background: #ffffff;
  padding: 0 58px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.content_boxs {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 58px;
  box-sizing: border-box;
}
.line {
  width: 4px;
  height: 24px;
  background-color: #5178ff;
  border-radius: 20px;
}
.title_text {
  font-size: 25px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #333333;
  margin-left: 10px;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  padding-right: 10px;
  box-sizing: border-box;
  margin-right: 22px;
  margin-bottom: 15px;
  display: flex;
  align-items: flex-end;
  width: 494px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #d4d4d4;
  opacity: 1;
  border-radius: 4px;
}
.fill_in_list_l {
  width: 130px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-right: 1px dashed #d4d4d4;
  height: 100%;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
input {
  background: none !important;
  outline: none !important;
  /* border: none !important; */
}
.input_box {
  border: none !important;
  width: 100%;
  height: 50px;
  margin-top: 9px;
  padding: 0 012px !important;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 50px;
  color: #2e3136;
}
</style>


// WEBPACK FOOTER //
// src/views/visit/visit.vue